App.filter('numberFormatter', ['$filter', function ($filter) {
    return function (number, digits) {
        number = number || '';
        if (number && number !== '-') {
            return Number(number).toLocaleString('pl-PL', {minimumFractionDigits: digits, maximumFractionDigits: digits});
        }
        return number;
    };
}]);